export default __webpack_public_path__ + "static/media/model_card-bg.6826c403.png";